import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { useCanOpenModule } from '@/hooks/useCanOpenModule'
import { useReturnHereState } from '@/lib/returnTo'

/** UF-11: a delivery note on the run page opens its delivery, and Back there
 *  returns to this run. Offered only to someone who holds Deliveries (the route
 *  gate's own check); everyone else, and anyone while the gate is deciding,
 *  sees plain text. */
export function RunDeliveryLink({ deliveryId, className, children }: {
  deliveryId: string | null | undefined
  className?: string
  children: ReactNode
}) {
  const canOpen = useCanOpenModule('deliveries')
  const here = useReturnHereState()
  if (!deliveryId || canOpen !== true) return <span className={className}>{children}</span>
  return (
    <Link to={`/deliveries/${deliveryId}`} state={here}
      className={`underline text-fg coarse:inline-flex coarse:items-center coarse:min-h-[44px] ${className ?? ''}`}>
      {children}
    </Link>
  )
}
